import { email, required, useGetIdentity, useRecordContext } from "ra-core";
import { BooleanInput } from "@/components/admin/boolean-input";
import { TextInput } from "@/components/admin/text-input";

import type { Sale } from "../types";

export function SalesInputs() {
  const { identity } = useGetIdentity();
  const record = useRecordContext<Sale>();
  return (
    <div className="space-y-4 w-full">
      <TextInput source="first_name" validate={required()} helperText={false} />
      <TextInput source="last_name" validate={required()} helperText={false} />
      <TextInput
        source="email"
        validate={[required(), email()]}
        helperText={false}
      />
      <BooleanInput
        source="administrator"
        label="Admin (full access)"
        readOnly={record?.id === identity?.id}
        helperText="Admins manage the team, analytics, and money approvals. Agents only see their own leads."
      />
      <BooleanInput
        source="disabled"
        label="Disable login"
        readOnly={record?.id === identity?.id}
        helperText="Disabled users cannot sign in. Prefer this over deleting accounts."
      />
    </div>
  );
}
